export function getTextHeight({ font, text, width }: { font: string; text: string; width: number }) {
  const temporaryElement = document.createElement('div');
  temporaryElement.style.width = `${width}px`;
  temporaryElement.style.font = font;
  temporaryElement.innerText = text;

  document.body.appendChild(temporaryElement);
  const { height } = temporaryElement.getBoundingClientRect();
  document.body.removeChild(temporaryElement);

  return height;
}
